import { render } from "./AlimtalkResults.vue?vue&type=template&id=22a872a5&scoped=true"
import script from "./AlimtalkResults.vue?vue&type=script&lang=js"
export * from "./AlimtalkResults.vue?vue&type=script&lang=js"

import "./AlimtalkResults.vue?vue&type=style&index=0&id=22a872a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a872a5"]])

export default __exports__